import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OAuthResourceServerErrorHandler } from 'angular-oauth2-oidc';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class OauthInterceptor implements HttpInterceptor {
  private readonly authService: AuthService = inject(AuthService);
  private readonly errorHandler: OAuthResourceServerErrorHandler = inject(
    OAuthResourceServerErrorHandler,
  );

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token: string | undefined = this.authService.accessToken();
    // Ignore all http calls to other services
    if (
      (!req.url.startsWith('/api/') &&
        !req.url.startsWith('/data/') &&
        !req.url.startsWith('/data-realtime/') &&
        !req.url.startsWith('https://iam.ndw.nu')) ||
      !token
    ) {
      return next.handle(req);
    }

    let header: string = `Bearer ${token}`;
    let headers: HttpHeaders = req.headers.set('Authorization', header);

    return next.handle(req.clone({ headers })).pipe(
      catchError((error: HttpResponse<HttpErrorResponse>): Observable<any> => {
        if (error.status === HttpStatusCode.Unauthorized) {
          this.authService.logout();
        }
        return this.errorHandler.handleError(error);
      }),
    );
  }
}
